import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleRight,
  faAngleDown,
  faFolder,
  faFolderOpen
} from "@fortawesome/free-solid-svg-icons";

const FolderIcon = styled.div`
  margin-right: 0.25rem;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
  color: ${props => props.theme.folder};
`;

const BulletContainer = styled.button`
  display: flex;
  margin-right: 0.25rem;
  margin-left: -1.25rem;
  min-width: 1rem;
  justify-content: center;
  height: 1.25rem;
  &:focus,
  &:active {
    outline: 0;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
`;

const FolderContainer = styled.li`
  margin-left: 1.5rem;
`;

const FolderContent = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 1.25rem;
  width: auto;
  &:focus,
  &:active {
    outline: 0;
  }
`;

const NestedTree = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

const TitleContainer = styled.div`
  text-align: left;
  padding: 0 0.25rem;
  background: ${props =>
    props.selected ? props.theme.colors.secondary : props.theme.background};
  color: ${props => props.theme.text.primary};
  justify-content: flex-start;
  width: auto;
  white-space: nowrap;
  border-radius: 5px;
`;

class Folder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: !!props.children
    };
  }

  onClick = (e, onlyExpand) => {
    if (
      this.props.children &&
      this.props.children.length > 0 &&
      (this.props.selected || onlyExpand)
    ) {
      this.setState({ expanded: !this.state.expanded });
    }
    if (!onlyExpand) {
      this.props.onSelected(this.props.id);
    }
  };

  render() {
    const { children, name, selected } = this.props;
    const { expanded } = this.state;
    return (
      <FolderContainer>
        <ContentWrapper>
          {children && children.length > 0 ? (
            <BulletContainer onClick={e => this.onClick(e, true)}>
              <FontAwesomeIcon
                fixedWidth
                icon={expanded ? faAngleDown : faAngleRight}
                size="lg"
              />
            </BulletContainer>
          ) : (
            ""
          )}
          <FolderContent onClick={e => this.onClick(e, false)}>
            <FolderIcon>
              <FontAwesomeIcon
                wixedWidth
                icon={expanded || !children ? faFolderOpen : faFolder}
                size="lg"
              />
            </FolderIcon>
            <TitleContainer title={name} selected={selected}>
              {name}
            </TitleContainer>
          </FolderContent>
        </ContentWrapper>
        {children && expanded ? <NestedTree>{children}</NestedTree> : ""}
      </FolderContainer>
    );
  }
}

Folder.defaultProps = {
  children: null,
  selected: false,
  onSelected: () => {},
  id: null
};

Folder.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  name: PropTypes.string.isRequired,
  id: PropTypes.number,
  selected: PropTypes.bool,
  onSelected: PropTypes.func
};

export default Folder;



// WEBPACK FOOTER //
// ./app/components/SavedItems/FolderTree/Folder.js